export const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);
export const normalizeForMatching = (text) => text.trim().toLowerCase().replace(/\s+/g, " ");
//# sourceMappingURL=string.js.map